import Vue from 'vue'
import VueRouter from 'vue-router'
import App from '../App.vue'
import Siteweb from '../Siteweb.vue'
import Dashboard from '../Dashboard.vue'
import aboutUs from '../views/siteweb/aboutUs'
import services from '../views/siteweb/services'
import voResult from '../views/siteweb/voResult'
import galeri from '../views/siteweb/galeri'
import conseil from '../views/siteweb/conseil'
import contact from '../views/siteweb/contact'
import news from '../views/siteweb/news'
import detailsNews from '../views/siteweb/detailsNews'
import notFound from '../views/siteweb/404'

// Admin Part
import MainApp from '../views/dashboard/mainApp'

Vue.use(VueRouter)

  const routes = [ 
  {
    path: '/',
    name: 'App',
    component: App, 
    redirect: {
      name: 'vip',
    }, 
    children: [{
          path: 'vip',
          name: 'vip',
          redirect: {
            name: 'vip',
          },
          component: Siteweb,
          props: true,
          children: [
              {
                path: 'accueil',
                name: 'vip',
                component: aboutUs,
                props: true,
              }, {
                path: 'services',
                name: 'services',
                component: services,
                props: true,
              }, {
                path: 'resultats',
                name: 'vosResult',
                component: voResult,
                props: true,
              }, {
                path: 'galeri',
                name: 'galeri',
                component: galeri,
                props: true,
              }, {
                path: 'espace_patient',
                name: 'conseil',
                component: conseil,
                props: true,
              }, {
                path: 'contact',
                name: 'contact',
                component: contact,
                props: true,
              }, {
                path: 'news',
                name: 'news',
                component: news, 
                props: true,
              }, {
                path: 'detailsNews',
                name: 'detailsNews',
                component: detailsNews,
                props: true,
              }, 
          ]
        },
        {
          path: 'admin',
          name: 'admin', 
          redirect: {
            name: 'mainApp'
          },
          component: Dashboard, 
          children: [
            {
              path: '/',
              name:'mainApp',
              component: MainApp
            }
          ]
        }
    ]
  }, 


  {
    path: '*',
    name: "*",
    component: notFound,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
